/**
 * The days of the week
 */
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

/**
 * The supported date range types
 */
export enum DateRangeType {
  Day = 0,
  Week = 1,
  Month = 2
}